import { ApiEnvironment } from '../../models/api-environment';
import { dataAccessEnvironment } from '../../models/data-access-environment';

export class AuthwsEnvironment extends ApiEnvironment {
  get authenticateUrl() {
    return `${this.baseUrl}/v2/security/authenticate`;
  }

  get accountListUrl() {
    return `${this.baseUrl}/account-list`;
  }

  get logoutUrl() {
    return `${this.baseUrl}/v2/security/logout`;
  }

  get partnerAccountsUrl() {
    return `${this.baseUrl}/v1/partner/accounts`;
  }

  get partnersUrl() {
    return `${this.baseUrl}/v1/partners`;
  }

  get passwordResetBulkUrl() {
    return `${this.baseUrl}/v1/password/reset/bulk`;
  }

  get productsUrl() {
    return `${this.baseUrl}/v1/users/${dataAccessEnvironment.authToken}/products`;
  }

  productsAccountsUrl(product: string, accountId: number) {
    return `${this.baseUrl}/v1/products/${product}/accounts/${accountId}`;
  }

  get tidAuthenticateUrl() {
    return `${this.baseUrl}/v1/trimbleid/authenticate`;
  }

  get tidMigrationStatusUrl() {
    return `${this.baseUrl}/v1/trimbleid/migration-status`;
  }

  get tokenUrl() {
    return `${this.baseUrl}/identity/v2/token`;
  }

  get verifyUrl() {
    return `${this.baseUrl}/v2/security/verify`;
  }
}

export const authwsEnvironment = new AuthwsEnvironment();
